<template>
    <div class="load-page">
        <van-loading size="40px" vertical>加载中...</van-loading>
    </div>
</template>
<script>
export default {
    name: 'Loading',
    props: {},
    data: function() {
        return {};
    },
    methods: {},
    created() {}
};
</script>

<style scoped>
.load-page {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 200px;
    background: #fff;
    color: #333;
    z-index: 999;
}
</style>
